import appConstants from '../appConstants'

//test urls for registration
// // const authorizeUrl = ' https://{BRAND}.marianatek.com/o/authorize'
// // https://demo-n9c5fm.marianatek.com/api/customer/v1/me/account
// // https://fhittingroom.marianatek.com/o/authorize?response_type=code&client_id=I0wk7V3kBW9vCmsWTU0ArMdhilc925wmrvU0Bmjy&redirect_uri=https://www.google.com%2Fcallback&prompt=true
// const ACC_URL = `https://fhittingroom.marianatek.com.marianatek.com/o/authorize?response_type=code&client_id=30276
// &redirect_uri=https://www.google.com&scope=read:account&state=1` 


let mapGetters = Vuex.mapGetters,
    mapActions = Vuex.mapActions;

export default {
    template: '#registration-component',
    delimiters: ['${', '}'],
    data() {
        return {
            userData: {
                firstName: null,
                lastName: null,
                email: null,
                password: null,
                location: null,
                phone: null,
                dateOfBirth: null,
                region: null,
                notifications: false,
                policies: false,
            },
            locations: [],
            filteredLocations: [],
            regions: [],
            regionSelected: false
        }
    },
    created() {
        //get Regions and Locations
        window.scrollTo(0,0);
        this.getStaticData(appConstants.DATA_REGIONS)
            .then(() => {
                return this.getStaticData(appConstants.DATA_LOCATIONS)
            })
            .then(() => {
                console.log(this.getRegions);
                console.log(this.getLocations);
                this.regions = [...this.getRegions];
                this.locations = [...this.getLocations];
            });
    },
    computed: {
        ...mapGetters([
            'getRegions',
            'getLocations'
        ]),
        regionsToSelect() {
            return this.regions.length ? this.regions.map((region) => {
                return region.name;
            }) : [];
        },
        locationsToSelect() {
            return this.filteredLocations.length ? this.filteredLocations.map((location) => {
                return location.name;
            }) : [];
        }
    },
    methods: {
        ...mapActions([
            'downloadData'
        ]),
        getStaticData(data) {
            return this.downloadData(data);
        },
        registrate() {
            //test data for registration
            // console.log(this.userData);
            // let dataToRecieve =
            //   {
            //     "first_name": "Sheila",
            //     "last_name": "Birt",
            //     "email": "1700boryana2@riskB1500.acc",
            //     "password": "123Qwe123",
            //     "phone_number": "09999879879",
            //     "birth_date": "1973-02-12",
            //     "home_location": {
            //       "id": "48066",
            //       "name": "West Hollywood"
            //     },
            //     "is_marketing_allowed": true,
            //     "is_waiver_signed": true
            //   }
            // ;
            // fetch(ACC_URL,{
            //   method: 'POST',
            //   body:JSON.stringify(dataToRecieve),
            //   headers: {
            //     'Content-Type': 'application/json'
            //   },
            // })
        },
        chooseLocation(selected) {
            this.userData.location = selected;
        },
        chooseRegion(selected) {

            // show locations select
            this.regionSelected = true;
            //fiter locations by region
            this.filteredLocations = this.locations.filter((location) => location.region.name === selected)
            console.log(this.filteredLocations);
            this.userData.region = selected;
        }
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/registrationComponent.js